let handleModals = function() {
  return $('#legalModal').on('show.bs.modal', function(event) {
    var clickedLegalLink, modal;
    clickedLegalLink = $(event.relatedTarget);
    modal = $(this);
    $('#legalTab a[href="' + clickedLegalLink.attr('href') + '"]').tab('show')
  });
};

let setupCheckboxHandlerFor = function($elements) {
  return $elements.on('click', function() {
    var $checkbox, isChecked;
    $checkbox = $(this);
    isChecked = $checkbox.is(':checked');
    if (isChecked) {
      return $('.create-account-button').removeClass("disabled").attr("disabled", false).attr("aria-pressed", false);
    } else {
      return $('.create-account-button').addClass("disabled").attr("disabled", true).attr("aria-pressed", true);
    }
  });
};

let setupCheckboxHandler = function() {
  return setupCheckboxHandlerFor($('.legal-checkbox'));
};


$(function() {
  handleModals();
  setupCheckboxHandler();
});
